import { HttpRequestConfig, HttpService, createHttpService } from '@/services/HttpService';
import { Setting } from '@/app/domain/Setting';
import { createUrlSearchParams } from '@/app/library/createUrlSearchParams';

type SettingsValue<T> = {
  tenant_id?: string;
  domain_object_id?: string;
  data: T
};
type SettingsValueResponse<T> = {
  items: SettingsValue<T>[];
};
type ServerSetting = SettingsValueResponse<Setting>;

export class SettingService {
  constructor(
    private tenantUuid: string,
    private httpService: HttpService
  ) {

  }

  public async getSetting(): Promise<Setting | null> {
    try {
      const serverSetting: ServerSetting = await this.httpService.get<void, ServerSetting>(
        '/api/settings/v1/TENANT/namespaces/com.acronis.partners/settings/partner.profile/values',
        {
          params: createUrlSearchParams({
            tenant_id: this.tenantUuid,
            domain_object_id: this.tenantUuid
          })
        }
      );
      return this.convertServerSettingToSetting(serverSetting);
    } catch (error) {
      return null;
    }
  }

  private convertServerSettingToSetting(serverSettings: ServerSetting): Setting {
    return serverSettings.items[0].data;
  }
}

export function createSettingService(selfTenantUuid: string, tenantUuid: string): SettingService {
  const httpService: HttpService = createHttpService(selfTenantUuid);

  return new SettingService(tenantUuid, httpService);
}
